import React, {useContext} from "react";
import "./Footer.css";
import {Fade} from "react-reveal";
import emoji from "react-easy-emoji";
import StyleContext from "../../contexts/StyleContext";

export default function Footer() {
  const {isDark} = useContext(StyleContext);
  return (
    <Fade bottom duration={1000} distance="5px">
      <div className="footer-div">
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          {emoji("Made by AmanDev Blockchain | Amy-Bcx")}
        </p>
        <p className={isDark ? "dark-mode footer-text" : "footer-text"}>
          <i>
          Theme by{" "}
          <a href="https://github.com/amy-bcx/developerFolio">
            Myself
          </a></i>
        </p>
      </div>
    </Fade>
  );
}
